import Reveal from '@/pages/zz-review/components/Reveal';

const evidences = [
  {
    tag: '歷史資料查證',
    title: '學員見證集',
    summary:
      'GAPICS 舊網站保存了 GPIM／CPIM++ 學員在研習期間留下的第一手見證。參與者來自半導體、電子、製造、藥業、顧問、教育與多國企業，內容呈現他們如何把所學帶回工作、團隊與跨國工廠。',
    linkText: '查看GPIM／CPIM++學員研習感言全集',
    link: 'http://gapics.big01.org/values/b3/c_seminar_testimony-all.htm',
    source: 'GAPICS 第一手歷史檔案；不是獨立第三方媒體報導。',
  },
  {
    tag: '歷史資料旁證',
    title: '產官學研協作推動',
    summary:
      '保存達太長期與產業、政府、學界及研究機構協作，推動製造管理、ERP、SCM、品質改善與人才培育的歷史紀錄。',
    linkText: '查看「共創臺灣經濟奇蹟的年代」',
    link: 'http://gapics.big01.org/values/b7_index.htm',
    source: 'GAPICS 第一手歷史紀錄。',
  },
];

export default function HistoricalEvidenceSection() {
  return (
    <section id="history-evidence" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10 md:mb-12">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              歷史資料查證
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              第一手歷史檔案
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              以下資料來自 GAPICS 自有歷史網站所保存的第一手紀錄，供讀者回查作者長年投入製造管理、ERP、SCM、品質改善與人才培育的歷史脈絡。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {evidences.map((e, i) => (
            <Reveal key={e.title} delay={i * 80}>
              <div className="h-full rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-7 flex flex-col">
                <span className="text-xs font-medium text-primary-700 mb-3">{e.tag}</span>
                <h3
                  className="text-lg md:text-xl text-foreground-900 mb-3"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {e.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-1">
                  {e.summary}
                </p>

                <a
                  href={e.link}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer mb-5 group whitespace-nowrap"
                >
                  <span className="underline-offset-4 group-hover:underline">{e.linkText}</span>
                  <i className="ri-arrow-right-up-line text-base" />
                </a>

                <p className="text-xs text-foreground-400 leading-relaxed border-t border-background-200/70 pt-4">
                  <i className="ri-information-line mr-1" />
                  {e.source}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}